var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5455 5.5H12.1818V6.82667H16.5455V16.18H3.45455V6.82667H7.81818V5.5H3.45455C2.65455 5.5 2 6.1 2 6.83333V16.1667C2 16.9 2.65455 17.5 3.45455 17.5H16.5455C17.3455 17.5 18 16.9 18 16.1667V6.83333C18 6.1 17.3455 5.5 16.5455 5.5ZM16.5455 5.5H12.1818V6.82667H16.5455V16.18H3.45455V6.82667H7.81818V5.5H3.45455C2.65455 5.5 2 6.1 2 6.83333V16.1667C2 16.9 2.65455 17.5 3.45455 17.5H16.5455C17.3455 17.5 18 16.9 18 16.1667V6.83333C18 6.1 17.3455 5.5 16.5455 5.5Z",
    fill: "#263238"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.32595 10.2143V3.74589H7.02148V2.61719H12.9707V3.74589H10.5957V10.2143H9.32595Z",
    fill: "#263238"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.832a1248e5c294aaf0d7b82b194d5675.svg";
export { ForwardRef as ReactComponent };